/**
* Featured Treatments JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Treatments component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'featured-treatments',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.featured-treatments' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--featured-treatments' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '32px',
          autoWidth: true,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-treatments', COMPONENT );
} )( app );
